export const offersName: any = {
  1: 'предложение',
  2: 'предложения',
  3: 'предложения',
  4: 'предложения',
  other: 'предложений',
}

export const flatNames: any = {
  1: 'квартира',
  2: 'квартиры',
  3: 'квартиры',
  4: 'квартиры',
  other: 'квартир',
}

export const getNumberOfOffers = (
  number: number,
  tableNames: any = offersName
): string => {
  const lengthNumber = number
  const lengthString = number.toString()

  if (lengthNumber && lengthString) {
    if (lengthNumber >= 5 && lengthNumber <= 20) {
      return `${lengthNumber} ${tableNames.other}`
    } else if (
      Number(lengthString[lengthString.length - 1]) >= 1 &&
      Number(lengthString[lengthString.length - 1]) < 5
    ) {
      return `${lengthNumber} ${
        tableNames[lengthString[lengthString.length - 1]]
      }`
    } else {
      return `${lengthNumber} ${tableNames.other}`
    }
  }

  return `Нет ${tableNames.other}`
}
